import { render, staticRenderFns } from "./PreferencesTemplates.vue?vue&type=template&id=ed175184"
import script from "./PreferencesTemplates.vue?vue&type=script&lang=js"
export * from "./PreferencesTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports